import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import {
  Translation,
  TRANSLOCO_LOADER,
  TranslocoLoader,
} from '@ngneat/transloco';
import { EnvService } from '../app/services/env.service';
@Injectable()
export class HttpLoader implements TranslocoLoader {
  private urlOnStart: string;

  constructor(
    private http: HttpClient,
    private envSevice: EnvService,
    private baseApiService: BaseAPIService
  ) {}

  public getTranslation(langPath: string) {
    this.urlOnStart = window.location.href;
    // Supply Cloud condition -- unsure what the supply cloud test url is
    if (
      this.urlOnStart.includes(':4201') ||
      this.urlOnStart.includes(':4202') ||
      this.urlOnStart.includes('supplycloud')
    ) {
      this.baseApiService.set(`/assets/i18n/sc/${langPath}.json`);
    } else {
      this.baseApiService.set(`/assets/i18n/marketplace/${langPath}.json`);
    }

    return this.baseApiService.get<Translation>({});
  }
}

export const httpLoader = { provide: TRANSLOCO_LOADER, useClass: HttpLoader };
